module.exports = __webpack_public_path__ + "img/event_check.068f273d.svg";